module.exports = __webpack_public_path__ + "img/tarj-1.2669d95a.svg";